// Lightweight route/nav index so the shell (App, Footer) never pulls the full guide copy into the main bundle.
// gen-seo.js asserts this stays in sync with data/guides.js at build time.
export const GUIDE_INDEX = [
  { slug: "financial-planner-singapore", nav: "Financial planners in Singapore" },
  { slug: "financial-advisory-singapore", nav: "Financial advisory in Singapore" },
  { slug: "retirement-planning-singapore", nav: "Retirement planning" },
  { slug: "legacy-planning-singapore", nav: "Legacy & estate planning" },
  { slug: "insurance-planning-singapore", nav: "Insurance planning" },
  { slug: "investment-planning-singapore", nav: "Investment planning" },
  { slug: "cpf-planning-singapore", nav: "CPF planning" },
  { slug: "employee-benefits-singapore", nav: "Employee benefits for SMEs" },
  { slug: "financial-advisor-career-singapore", nav: "Financial advisor careers" },
  { slug: "how-to-become-a-financial-advisor-singapore", nav: "How to become a financial advisor" },
];

export const GUIDE_ZH_SLUGS = ["retirement-planning-singapore", "cpf-planning-singapore", "legacy-planning-singapore", "how-to-become-a-financial-advisor-singapore"];
